import { getSession } from './embed/store/session/guest';
import { setLastActivity } from './embed/store/session/guest.storage';
import sharedConfig from './shared_config';
export default {
    sessionGetter: getSession,
    lastActivitySetter: setLastActivity,
    tracking: {
        urls: ({ videoId }) => ({
            engagement: `/embed/videos/${videoId}/engagements`,
            views: `/embed/videos/${videoId}/views`,
            picked_video: `/embed/picked_videos/${videoId}`,
            thumbnailImpressions: '/embed/thumbnail_impressions',
            ctaImpressions: '/embed/cta_impressions',
            scrollVideos: '/embed/scroll_videos',
            scrollEndVideos: '/embed/scroll_end_videos',
        }),
        pixelUrls: () => (Object.assign({}, sharedConfig.tracking.pixelUrls)),
    },
};
